export const CONFIRM_MESSAGE = 'Сохраните внесенную информацию. Несохраненные данные будут удалены';
